interface DividerWithTextProps {
	text: string;
	widthClass?: string;
}

export const DividerWithText = ({ text, widthClass = 'w-[340px]' }: DividerWithTextProps) => (
	<div className={`flex items-center justify-center ${widthClass}`}>
		<div className="flex-grow border-t border-black opacity-10" />
		<span className="px-4 text-gray-500 roboto-regular font-base">{text}</span>
		<div className="flex-grow border-t border-black opacity-10" />
	</div>
);
